import { render, staticRenderFns } from "./BLUV2LotEditModal.vue?vue&type=template&id=732cafdc&scoped=true"
import script from "./BLUV2LotEditModal.vue?vue&type=script&lang=js"
export * from "./BLUV2LotEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cafdc",
  null
  
)

export default component.exports